import { giveNumber } from "../../../../utils/utils";
//DEFAULTS
export const DEFAULT_RESOURCE = (uuid) => ({
  id: uuid,
  role: "",
  assignees: [],
  rate: "",
});

export const getDefaultDeliverables = (project) => {
  const deliverables = project?.deliverables;
  return deliverables?.map((deliverable) => {
    return {
      id: deliverable?.id,
      name: deliverable?.name,
      tasks: deliverable?.tasks
        ?.filter((task) => task?.organization === "FKA")
        ?.map((task) => {
          return {
            id: task?.id,
            // Map task.description to a 'name' property for the default structure
            name: task?.description,
            resources: [],
          };
        }),
    };
  });
};

export const compareAndTakeUnionOfDefaultAndSavedDeliverables = (
  defaultDeliverables,
  savedDeliverables,
  savedResources
) => {
  const savedTasksList = savedDeliverables?.map((x) => x?.tasks)?.flat();

  const defaultDeliverablesUpdated = defaultDeliverables.map((deliverable) => {
    return {
      ...deliverable,
      tasks: deliverable?.tasks?.map((task) => {
        const findSavedTask = savedTasksList?.find((x) => x?.id === task?.id);
        return {
          ...task,
          resources:
            findSavedTask?.resources ||
            savedResources?.map((x) => ({
              hours: 0,
              id: x?.id,
              isEnabled: false,
            })),
        };
      }),
    };
  });
  return defaultDeliverablesUpdated;
};

// CALCULATIONS
export const calculateBudgetForTask = (task, resources) => {
  const data = task?.resources?.reduce(
    (acc, x) => {
      if (x?.isEnabled) {
        const projResource = resources?.find((res) => res?.id === x?.id);
        const hours = giveNumber(x?.hours);
        return {
          hours: acc?.hours + hours,
          value: acc?.value + giveNumber(projResource?.rate) * hours,
        };
      }
      return acc;
    },
    { hours: 0, value: 0 }
  );

  return data || data || { hours: 0, value: 0 };
};

export const calculateBudgetForDeliverable = (deliverable, resources) => {
  const data = deliverable?.tasks?.reduce(
    (acc, task) => {
      const { hours, value } = calculateBudgetForTask(task, resources);

      return {
        hours: acc?.hours + hours,
        value: acc?.value + value,
      };
    },
    { hours: 0, value: 0 }
  );

  return data || { hours: 0, value: 0 };
};

export const calculateBudgetForProject = (deliverables, resources) => {
  const data = deliverables?.reduce(
    (acc, deliverable) => {
      const { hours, value } = calculateBudgetForDeliverable(
        deliverable,
        resources
      );

      return {
        hours: acc?.hours + hours,
        value: acc?.value + value,
      };
    },
    { hours: 0, value: 0 }
  );

  return data || { hours: 0, value: 0 };
};

//////////////PARSERS FOR APPLICATION

//get roles list with summed hours, cost for each deliverable
export const getRolesListForDeliverable = (deliverable, resources) => {
  if (!deliverable) return [];
  const list = deliverable?.tasks?.map((x) => x?.resources)?.flat();
  const valuesObj = list?.reduce((acc, resource) => {
    const id = resource?.id;
    return { ...acc, [id]: Number(resource?.hours) + (acc?.[id] || 0) };
  }, {});

  const filteredResourcesList = resources?.filter((resource) => {
    return list.some((x) => resource?.id === x?.id && x?.isEnabled);
  });

  const resourcesList = filteredResourcesList?.map((x) => {
    return {
      ...x,
      value: x?.rate * valuesObj?.[x?.id] || 0,
      hours: valuesObj?.[x?.id],
    };
  });

  return resourcesList;
};

///////////////constants

export const BUILDER_ALERTS_MESSAGES = {
  "save-error": {
    description:
      "Unable to save budget. Any role toggled on must have a value added to it.",
  },
  "save-success": {
    description: "Congratulations, you just saved your budget!",
  },
  delete: {
    description: `Unable to delete role. You cannot delete a role with time logged against it.`,
  },
  "toggle-off": {
    description:
      "Unable to remove role. You cannot toggle off a role with time logged against it.",
  },
  "last-resource": {
    description: "The sole resource in the budget builder cannot be deleted.",
  },
  "change-rate-default": {
    description: `Are you sure? Choosing the "Rates (Default)" option will reset all role rates to the system's default values.`,
  },
  "change-rate-flat": {
    description: `Are you sure? Choosing the "Rates (Flat)" option will override all the default role rates.`,
  },
};

export const checkIfAllDeliverablesHaveHours = (deliverables) => {
  return deliverables?.every((del) => {
    const tasks = del?.tasks;
    return tasks?.every((task) => {
      const resources = task?.resources;
      return resources?.every((res) => {
        if (!res?.isEnabled) return true;
        return res?.isEnabled && res?.hours > 0;
      });
    });
  });
};
